
export const getCreditVettingInitialState = (vettingCreditDetails, numberOfSections, isHideVetAddress = false) => ({
  personalDetails: {
    identifier: 'personalDetails',
    logo: 'PersonIcon',
    title: 'Personal details',
    sectionOf: `Section 1 of ${ numberOfSections }`,
    showBody: true,
    enableNext: false,
    isDataAvailable: vettingCreditDetails.personalDetails ? true : false,
    showNext: 'contactDetails',
    isEditModeOn: false
  },
  contactDetails: {
    identifier: 'contactDetails',
    logo: 'CellPhoneIcon',
    title: 'Contact details',
    sectionOf: `Section 2 of ${ numberOfSections }`,
    showBody: vettingCreditDetails.personalDetails ? true : false || vettingCreditDetails.contactDetails ? true : false,
    enableNext: false,
    isDataAvailable: vettingCreditDetails.contactDetails ? true : false,
    showNext: 'workDetails',
    isEditModeOn: false
  },
  workDetails: {
    identifier: 'workDetails',
    logo: 'SuitCaseIcon',
    title: 'Work details',
    sectionOf: `Section 3 of ${ numberOfSections }`,
    showBody: vettingCreditDetails.contactDetails ? true : false || vettingCreditDetails.workDetails ? true : false,
    enableNext: false,
    isDataAvailable: vettingCreditDetails.workDetails ? true : false,
    showNext: isHideVetAddress ? 'bankAccountDetails' : 'homeAddress',
    isEditModeOn: false
  },
  homeAddress: {
    identifier: 'homeAddress',
    logo: 'HomeIcon',
    title: 'Home address',
    sectionOf: `Section 4 of ${ numberOfSections }`,
    showBody: vettingCreditDetails.workDetails ? true : false || vettingCreditDetails.homeAddress ? true : false,
    enableNext: false,
    isDataAvailable: vettingCreditDetails.homeAddress ? true : false,
    showNext: 'postalAddress',
    isEditModeOn: false
  },
  postalAddress: {
    identifier: 'postalAddress',
    logo: 'PostalIcon',
    title: 'Postal address',
    sectionOf: `Section 5 of ${ numberOfSections }`,
    showBody: vettingCreditDetails.homeAddress ? true : false || vettingCreditDetails.postalAddress ? true : false,
    enableNext: false,
    isDataAvailable: vettingCreditDetails.postalAddress ? true : false,
    showNext: 'bankAccountDetails',
    isEditModeOn: false
  },
  bankAccountDetails: {
    identifier: 'bankAccountDetails',
    logo: 'CurrencyIcon',
    title: 'Bank account details',
    sectionOf: `Section ${ isHideVetAddress ? 4 : 6 } of ${ numberOfSections }`,
    showBody: vettingCreditDetails.postalAddress ? true : false || vettingCreditDetails.bankDetails ? true : false,
    enableNext: false,
    isDataAvailable: vettingCreditDetails.bankDetails ? true : false,
    showNext: 'creditCheck',
    isEditModeOn: false
  },
  creditCheck: {
    identifier: 'creditCheck',
    logo: 'PlainTick',
    title: 'Credit check consent',
    sectionOf: `Section ${ isHideVetAddress ? 5 : 7 } of ${ numberOfSections }`,
    showBody: vettingCreditDetails.bankDetails ? true : false || vettingCreditDetails.creditCheckDetails ? true : false,
    enableNext: false,
    isDataAvailable: vettingCreditDetails.creditCheckDetails ? true : false,
    showNext: '',
    isEditModeOn: false
  }
});

export const createFormComponentsConfig = (contactDetailsData) => ({
  cellPhoneNo: {
    name: 'Cellphone number',
    type: 'input',
    value: contactDetailsData?.cellPhoneNo.value || '',
    width: 100,
    validations: {
      type: 'cellphoneNo',
      required: true,
      invalidMessage: 'Please enter a valid cell phone number'
    },
    config: {
      type: 'text',
      required: true,
      placeholder: 'Add cellphone number',
      tabIndex: '14'
    },
    isValid: false,
    isTouched: false
  },
  email: {
    name: 'Email address',
    type: 'input',
    value: contactDetailsData?.email.value || '',
    width: 100,
    validations: {
      type: 'email',
      required: true,
      invalidMessage: 'Please enter a valid email address'
    },
    config: {
      type: 'text',
      required: true,
      placeholder: 'Add email address',
      tabIndex: '15'
    },
    isValid: false,
    isTouched: false
  },
  secondaryEmail: {
    name: 'Secondary email address ',
    type: 'input',
    value: contactDetailsData?.secondaryEmail?.value || '',
    width: 100,
    optional: true,
    validations: {
      type: 'email',
      required: false,
      invalidMessage: 'Please enter a valid email address'
    },
    config: {
      type: 'text',
      required: false,
      placeholder: 'Add secondary email address',
      tabIndex: '15'
    },
    isValid: true,
    isTouched: false
  },
  altContactPerson: {
    name: 'Alternative contact person ',
    type: 'input',
    optional: true,
    value: contactDetailsData?.altContactPerson?.value || '',
    width: 100,
    validations: {
      required: false,
      invalidMessage: 'Please enter a valid name',
      maxLength: 50,
      peerInputs: [ 'altCellPhoneNo' ],
      isPeerTouched: false
    },
    config: {
      type: 'text',
      required: false,
      placeholder: 'Add alternative contact person',
      tabIndex: '3'
    },
    isValid: true,
    isTouched: false
  },
  altCellPhoneNo: {
    name: 'Alternative cellphone number ',
    type: 'input',
    optional: true,
    value: contactDetailsData?.altCellPhoneNo.value || '',
    width: 100,
    validations: {
      type: 'cellphoneNo',
      required: false,
      invalidMessage: 'Please enter a valid cell phone number',
      peerInputs: [ 'altContactPerson' ],
      isPeerTouched: false
    },
    config: {
      type: 'text',
      required: true,
      placeholder: 'Add alternate cellphone number',
      tabIndex: '14'
    },
    isValid: true,
    isTouched: false
  }
});

const DefaultMonthDays = [ '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31' ];
const DefaultOccupationTypes = [ 'Full time/permanent', 'Pensioner/retired', 'Self employed', 'Unemployed', 'Student', 'Casual/contractor' ];
const DefaultEmployerCategories = [ 'Employee', 'Sole Owner', 'Member/Director' ];

export const createWorkDetailsFormConfig = (workDetails, { occupationTypesArray, employmentIndustryArray, employerCategoryArray, salaryDayArray, salaryFrequencyArray }) => ({
  occupationType: {
    name: 'Occupation type',
    type: 'dropDown',
    value: workDetails?.occupationType?.value || '',
    options: occupationTypesArray || DefaultOccupationTypes,
    width: 100,
    validations: {
      required: true,
      invalidMessage: 'Please enter the occupation type'
    },
    config: {
      type: 'select',
      required: true,
      placeholder: 'Select occupation type',
      tabIndex: '16'
    },
    isValid: false,
    isTouched: false
  },
  employerName: {
    name: 'Employer name',
    type: 'input',
    value: workDetails?.employerName?.value || '',
    width: 100,
    validations: {
      required: true,
      invalidMessage: 'Please enter the name of your employer',
      maxLength: 50
    },
    config: {
      type: 'text',
      required: true,
      placeholder: 'Add employer name',
      tabIndex: '17',
      size: '50',
      maxLength: '50'
    },
    isValid: false,
    isTouched: false
  },
  employerIndustry: {
    name: 'Employer industry',
    type: 'dropDown',
    value: workDetails?.employerIndustry?.value || '',
    options: employmentIndustryArray || [ 'Tellecommunication' ],
    width: 100,
    validations: {
      required: true,
      invalidMessage: 'Please select your employer industry'
    },
    config: {
      type: 'select',
      required: true,
      placeholder: 'Select employer industry',
      tabIndex: '18'
    },
    isValid: false,
    isTouched: false
  },
  employerPhoneNumber: {
    name: 'Employer phone number',
    type: 'input',
    value: workDetails?.employerPhoneNumber?.value || '',
    width: 100,
    validations: {
      type: 'workNo',
      required: true,
      invalidMessage: 'Please enter your employer phone number'
    },
    config: {
      type: 'text',
      required: true,
      placeholder: 'Add employer phone number',
      tabIndex: '19'
    },
    isValid: false,
    isTouched: false
  },
  employerCategory: {
    name: 'Employer category',
    type: 'dropDown',
    value: workDetails?.employerCategory?.value || '',
    options: employerCategoryArray || DefaultEmployerCategories,
    width: 100,
    validations: {
      required: true,
      invalidMessage: 'Please select your employer category'
    },
    config: {
      type: 'select',
      required: true,
      placeholder: 'Select employer category',
      tabIndex: '21'
    },
    isValid: false,
    isTouched: false
  },
  grossMonthlySalary: {
    name: 'Gross monthly salary',
    note:'This is your monthly salary before deductions',
    type: 'input',
    value: workDetails?.grossMonthlySalary?.value || '',
    width: 100,
    validations: {
      required: true,
      type: 'number',
      invalidMessage: 'Please enter your gross monthly salary'
    },
    config: {
      type: 'number',
      required: true,
      placeholder: 'R',
      tabIndex: '22'
    },
    isValid: false,
    isTouched: false
  },
  salaryDay: {
    name: 'Salary day',
    type: 'dropDown',
    value: workDetails?.salaryDay?.value || '',
    options: salaryDayArray || DefaultMonthDays,
    width: 50,
    validations: {
      required: true,
      invalidMessage: 'Please select your salary date'
    },
    config: {
      type: 'select',
      required: true,
      placeholder: 'Select',
      tabIndex: '23'
    },
    isValid: false,
    isTouched: false
  },
  salaryFrequency: {
    name: 'Salary frequency',
    type: 'dropDown',
    value: workDetails?.salaryFrequency?.value || '',
    options: salaryFrequencyArray || [ 'Weekly', 'Monthly' ],
    width: 50,
    validations: {
      required: true,
      invalidMessage: 'Please select your salary frequency'
    },
    config: {
      type: 'select',
      required: true,
      placeholder: 'Select frequency',
      tabIndex: '24'
    },
    isValid: false,
    isTouched: false
  }
});
